
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const ContentDetailsPage = lazy(() => import('../pages/content-details/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const MyLibraryPage = lazy(() => import('../pages/my-library/page'));
const FavoritesPage = lazy(() => import('../pages/favorites/page'));
const NotificationsPage = lazy(() => import('../pages/notifications/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/category/:categoryId',
    element: <CategoryPage />
  },
  {
    path: '/content/:contentId',
    element: <ContentDetailsPage />
  },
  {
    path: '/checkout/:contentId',
    element: <CheckoutPage />
  },
  {
    path: '/my-library',
    element: <MyLibraryPage />
  },
  {
    path: '/favorites',
    element: <FavoritesPage />
  },
  {
    path: '/notifications',
    element: <NotificationsPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/search',
    element: <SearchPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
